import { extendTheme } from '@chakra-ui/react';
import baseTheme from './baseTheme';
import { BaseThemeProps } from './BaseThemeProps';

// this would be in a separate file
const chakraColorSchemes: any = {};
const colors: {} | undefined = baseTheme.colors;
if (colors) {
  Object.keys(colors).map((color, i) => {
    const scheme = {
      500: Object.values(colors)[i]
    };
    chakraColorSchemes[`${color}Scheme`] = scheme;
  });
  const rainbowScheme = {
    50: 'black',
    100: 'cyan',
    200: 'yellow',
    300: 'magenta',
    400: 'red',
    500: 'blue',
    600: 'grey',
    700: 'white',
    800: 'green',
    900: 'orange'
  };
  chakraColorSchemes.rainbowScheme = rainbowScheme;
}

const baseStyle = {
  tablist: {
    w: '1146px',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'row',
    listStyleType: 'none',
    borderBottom: `1px solid ${baseTheme?.colors?.lightGrey}`
  },
  tab: {
    position: 'relative',
    minW: '170px',
    maxW: '170px',
    fontFamily: baseTheme.fonts?.regular,
    fontSize: '20px',
    textAlign: 'center',
    color: baseTheme.colors?.mediumGrey,
    cursor: 'pointer',
    padding: '11px',
    _selected: {
      fontFamily: baseTheme.fonts?.bold,
      cursor: 'auto',
      _after: { opacity: 1 }
    },
    _after: {
      width: '170px',
      height: '5px',
      position: 'absolute',
      left: '0px',
      bottom: '-2.5px',
      content: '" "',
      borderRadius: '2.5px',
      opacity: 0
    }
  }
};

const defaultSecondary = {
  tablist: {
    height: '52px',
    justifyContent: 'space-around',
    borderBottom: 'none',
    padding: 0,
    margin: 0
  },
  tab: {
    fontSize: '16px',
    maxW: 'none',
    _after: { display: 'none' }
  }
};

const defaultSmallPrimary = {
  tablist: {
    maxW: '1146px',
    height: '36px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignContent: 'left',
    flexDirection: 'row',
    listStyleType: 'none',
    borderBottom: `1px solid ${baseTheme?.colors?.lightGrey}`
  },
  tab: {
    fontSize: '16px',
    lineHeight: '16px',
    textAlign: 'flex-start',
    justifyContent: 'flex-start',
    minW: '75px',
    maxW: '117px',
    minHeight: '26px',
    padding: '5px 10px 5px 10px',
    marginLeft: '4px',
    _selected: {
      fontFamily: baseTheme.fonts?.bold,
      cursor: 'auto',
      _after: { opacity: 1 }
    },
    _after: {
      // maxWidth: '117px',
      // minWidth: '75px',
      width: '100%',
      height: '5px',
      position: 'absolute',
      left: '0px',
      bottom: '-2.5px',
      content: '" "',
      borderRadius: '5px',
      opacity: 0
    }
  }
};

const defaultSmallSecondary = {
  tablist: {
    height: '42px',
    maxW: '1146px',
    justifyContent: 'flex-start',
    alignContent: 'left',
    borderBottom: 'none',
    padding: 0,
    margin: 0
  },
  tab: {
    fontSize: '14px',
    lineHeigh: '14px',
    _after: { display: 'none' }
  }
};

const baseStyleTT = {
  zIndex: 1400
};

export const chakraTheme: BaseThemeProps = extendTheme({
  ...baseTheme,
  shadows: {
    outline: 'none'
  },
  colors: {
    ...chakraColorSchemes, // include both new schemes and previus colors
    ...baseTheme.colors
  },
  textStyles: {
    'regular-8-8': {
      fontFamily: 'OpenSans Regular',
      fontSize: '8px',
      lineHeight: '8px'
    },
    'bold-8-8': {
      fontFamily: 'OpenSans Bold',
      fontSize: '8px',
      lineHeight: '8px'
    },
    'regular-8-10': {
      fontFamily: 'OpenSans Regular',
      fontSize: '8px',
      lineHeight: '10px'
    },
    'regular-10-10': {
      fontFamily: 'OpenSans Regular',
      fontSize: '10px',
      lineHeight: '10px'
    },
    'regularItalic-10-10': {
      fontFamily: 'OpenSans Italic',
      fontSize: '10px',
      lineHeight: '10px'
    },
    'semiBold-8-8': {
      fontFamily: 'OpenSans Bold',
      fontSize: '10px',
      lineHeight: '10px'
    },
    'semiBold-10-10': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '10px',
      lineHeight: '10px'
    },
    'regular-10-12': {
      fontFamily: 'OpenSans Regular',
      fontSize: '10px',
      lineHeight: '12px'
    },
    'semiBold-10-12': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '10px',
      lineHeight: '12px'
    },
    'bold-10-12': {
      fontFamily: 'OpenSans Bold',
      fontSize: '10px',
      lineHeight: '12px'
    },
    'regular-10-14': {
      fontFamily: 'OpenSans Regular',
      fontSize: '10px',
      lineHeight: '14px'
    },
    'semiBold-10-14': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '10px',
      lineHeight: '14px'
    },
    'semiBold-10-16': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '10px',
      lineHeight: '16px'
    },
    'regular-11-14': {
      fontFamily: 'OpenSans Regular',
      fontSize: '11px',
      lineHeight: '14px'
    },
    'regular-11-15': {
      fontFamily: 'OpenSans Regular',
      fontSize: '11px',
      lineHeight: '15px'
    },
    'regular-11-16': {
      fontFamily: 'OpenSans Regular',
      fontSize: '11px',
      lineHeight: '16px'
    },
    'regular-12-12': {
      fontFamily: 'OpenSans Regular',
      fontSize: '12px',
      lineHeight: '12px'
    },
    'semiBold-12-12': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '12px',
      lineHeight: '12px'
    },
    'bold-12-12': {
      fontFamily: 'OpenSans Bold',
      fontSize: '12px',
      lineHeight: '12px'
    },
    'regular-12-14': {
      fontFamily: 'OpenSans Regular',
      fontSize: '12px',
      lineHeight: '14px'
    },
    'semiBold-12-14': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '12px',
      lineHeight: '14px'
    },
    'bold-12-14': {
      fontFamily: 'OpenSans Bold',
      fontSize: '12px',
      lineHeight: '14px'
    },
    'regular-12-16': {
      fontFamily: 'OpenSans Regular',
      fontSize: '12px',
      lineHeight: '16px'
    },
    'semiBold-12-16': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '12px',
      lineHeight: '16px'
    },
    'semiBoldItalic-12-16': {
      fontFamily: 'OpenSans Semi Bold Italic',
      fontSize: '12px',
      lineHeight: '16px'
    },
    'bold-12-16': {
      fontFamily: 'OpenSans Bold',
      fontSize: '12px',
      lineHeight: '16px'
    },
    'regular-12-19': {
      fontFamily: 'OpenSans Regular',
      fontSize: '12px',
      lineHeight: '19px'
    },
    'semiBold-12-19': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '12px',
      lineHeight: '19px'
    },
    'regular-12-20': {
      fontFamily: 'OpenSans Regular',
      fontSize: '12px',
      lineHeight: '20px'
    },
    'regular-14-14': {
      fontFamily: 'OpenSans Regular',
      fontSize: '14px',
      lineHeight: '14px'
    },
    'regular-14-16': {
      fontFamily: 'OpenSans Regular',
      fontSize: '14px',
      lineHeight: '16px'
    },
    'semiBold-14-16': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '14px',
      lineHeight: '16px'
    },
    'bold-14-16': {
      fontFamily: 'OpenSans Bold',
      fontSize: '14px',
      lineHeight: '16px'
    },
    'semiBold-14-18': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '14px',
      lineHeight: '18px'
    },
    'semiBold-14-19': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '14px',
      lineHeight: '19px'
    },
    'regular-14-19': {
      fontFamily: 'OpenSans Regular',
      fontSize: '14px',
      lineHeight: '19px'
    },
    'semiBoldItalic-14-19': {
      fontFamily: 'OpenSans Semi Bold Italic',
      fontSize: '14px',
      lineHeight: '19px'
    },
    'regularItalic-14-19': {
      fontFamily: 'OpenSans Italic',
      fontSize: '14px',
      lineHeight: '19px'
    },
    'bold-14-19': {
      fontFamily: 'OpenSans Bold',
      fontSize: '14px',
      lineHeight: '19px'
    },
    'light-14-19': {
      fontFamily: 'OpenSans Light',
      fontSize: '14px',
      lineHeight: '19px'
    },
    'regular-14-20': {
      fontFamily: 'OpenSans Regular',
      fontSize: '14px',
      lineHeight: '20px'
    },
    'semiBoldItalic-14-20': {
      fontFamily: 'OpenSans Semi Bold Italic',
      fontSize: '14px',
      lineHeight: '20px'
    },
    'regularItalic-14-20': {
      fontFamily: 'OpenSans Italic',
      fontSize: '14px',
      lineHeight: '20px'
    },
    'regular-14-30': {
      fontFamily: 'OpenSans Regular',
      fontSize: '14px',
      lineHeight: '30px'
    },
    'semiBold-15-20': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '15px',
      lineHeight: '20px'
    },
    'regular-16-16': {
      fontFamily: 'OpenSans Regular',
      fontSize: '16px',
      lineHeight: '16px'
    },
    'semiBold-16-16': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '16px',
      lineHeight: '16px'
    },
    'bold-16-16': {
      fontFamily: 'OpenSans Bold',
      fontSize: '16px',
      lineHeight: '16px'
    },
    'regular-16-20': {
      fontFamily: 'OpenSans Regular',
      fontSize: '16px',
      lineHeight: '20px'
    },
    'regular-16-22': {
      fontFamily: 'OpenSans Regular',
      fontSize: '16px',
      lineHeight: '22px'
    },
    'semiBold-16-22': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '16px',
      lineHeight: '22px'
    },
    'bold-16-22': {
      fontFamily: 'OpenSans Bold',
      fontSize: '16px',
      lineHeight: '22px'
    },
    'semiBold-16-24': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '16px',
      lineHeight: '24px'
    },
    'regular-18-25': {
      fontFamily: 'OpenSans Regular',
      fontSize: '18px',
      lineHeight: '25px'
    },
    'semiBold-18-18': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '18px',
      lineHeight: '18px'
    },
    'semiBold-18-25': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '18px',
      lineHeight: '25px'
    },
    'bold-18-25': {
      fontFamily: 'OpenSans Bold',
      fontSize: '18px',
      lineHeight: '25px'
    },
    'regular-20-24': {
      fontFamily: 'OpenSans Regular',
      fontSize: '20px',
      lineHeight: '24px'
    },
    'semiBold-20-26': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '20px',
      lineHeight: '26px'
    },
    'semiBold-20-27': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '20px',
      lineHeight: '27px'
    },
    'bold-20-27': {
      fontFamily: 'OpenSans Bold',
      fontSize: '20px',
      lineHeight: '27px'
    },
    'semiBold-22-24': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '22px',
      lineHeight: '24px'
    },
    'bold-24-24': {
      fontFamily: 'OpenSans Bold',
      fontSize: '24px',
      lineHeight: '24px'
    },
    'regular-24-30': {
      fontFamily: 'OpenSans Regular',
      fontSize: '24px',
      lineHeight: '30px'
    },
    'semiBold-24-30': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '24px',
      lineHeight: '30px'
    },
    'semiBold-26-26': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '26px',
      lineHeight: '26px'
    },
    'bold-26-50': {
      fontFamily: 'OpenSans Bold',
      fontSize: '26px',
      lineHeight: '50px'
    },
    'bold-32-32': {
      fontFamily: 'OpenSans Bold',
      fontSize: '32px',
      lineHeight: '32px'
    },
    'regular-30-30': {
      fontFamily: 'OpenSans Regular',
      fontSize: '30px',
      lineHeight: '30px'
    },
    'semiBold-30-36': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '30px',
      lineHeight: '36px'
    },
    'regular-35-34': {
      fontFamily: 'OpenSans Regular',
      fontSize: '35px',
      lineHeight: '34px'
    },
    'regular-36-40': {
      fontFamily: 'OpenSans Regular',
      fontSize: '36px',
      lineHeight: '40px'
    },
    'semiBold-36-40': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '36px',
      lineHeight: '40px'
    },
    'bold-36-40': {
      fontFamily: 'OpenSans Bold',
      fontSize: '36px',
      lineHeight: '40px'
    },
    'semiBold-40-40': {
      fontFamily: 'OpenSans Semi Bold',
      fontSize: '40px',
      lineHeight: '40px'
    },
    'bold-40-40': {
      fontFamily: 'OpenSans Bold',
      fontSize: '40px',
      lineHeight: '40px'
    },
    'regular-180-245': {
      fontFamily: 'OpenSans Regular',
      fontSize: '180px',
      lineHeight: '245px'
    },
    'regular-250-340': {
      fontFamily: 'OpenSans Regular',
      fontSize: '250px',
      lineHeight: '340px'
    }
  },
  components: {
    Checkbox: {
      baseStyle: {
        label: {
          marginStart: '5px'
        }
      }
    },
    Tabs: {
      parts: ['tablist', 'tab'],
      baseStyle: baseStyle,
      variants: {
        primaryGreen: {
          tab: {
            _selected: {
              color: baseTheme.colors?.greenMedium
            },
            _after: {
              backgroundColor: baseTheme.colors?.greenMedium
            }
          }
        },
        secondaryGreen: {
          tab: {
            ...defaultSecondary.tab,
            _selected: {
              color: baseTheme.colors?.greenMedium
            }
          },
          tablist: {
            ...defaultSecondary.tablist,
            background: 'rgba(147,228,193,0.2)'
          }
        },
        primaryBlue: {
          tab: {
            _hover: {
              color: baseTheme.colors?.blueTwo
            },
            _selected: {
              color: baseTheme.colors?.blueOne
            },
            _after: {
              backgroundColor: baseTheme.colors?.blueOne
            }
          }
        },
        secondaryBlue: {
          tab: {
            ...defaultSecondary.tab,
            _selected: {
              color: baseTheme.colors?.blueOne
            },
            _hover: {
              color: baseTheme.colors?.blueTwo
            }
          },
          tablist: {
            ...defaultSecondary.tablist,
            background: 'rgba(0, 159, 211, 0.1)'
          }
        },
        smallPrimaryBlue: {
          tab: {
            ...defaultSmallPrimary.tab,
            _hover: {
              color: baseTheme.colors?.blueTwo
            },
            _selected: {
              color: baseTheme.colors?.blueOne,
              _after: { width: '100%' }
            },
            _after: {
              backgroundColor: baseTheme.colors?.blueOne
            }
          },
          tablist: {
            ...defaultSmallPrimary.tablist
          }
        },
        smallSecondaryBlue: {
          tab: {
            ...defaultSmallSecondary.tab,
            _selected: {
              color: baseTheme.colors?.blueOne
            },
            _hover: {
              color: baseTheme.colors?.blueTwo
            }
          },
          tablist: {
            ...defaultSmallSecondary.tablist,
            background: 'rgba(0, 159, 211, 0.1)'
          }
        }
      },
      sizes: {},
      defaultProps: {
        size: ''
      }
    },
    Tooltip: {
      baseStyle: baseStyleTT
    }
  }
});
